"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModule = void 0;
/**
 * An abstract class that all client modules should extend.
 *
 * @example
 * class MyModule extends BaseModule {
 *   public async getMyData(): Promise<MyData> {
 *     return this.baseClient.get('/my-data');
 *   }
 *
 *   public async createMyData(data: MyData): Promise<MyData> {
 *     return this.baseClient.post('/my-data', data);
 *   }
 *
 *   public async getName(): Promise<string> {
 *     return this.baseClient.get('/my-data/name');
 *   }
 * }
 *
 * export class MyServiceClient extends BaseClient {
 *   // declare the module instance(s) that will be available on the client
 *   public declare readonly myModule: MyModule;
 *
 *   constructor() {
 *     // pass the <propName, Module constructor> to the super constructor to register the modules
 *     super(...clientConfig, { myModule: MyModule });
 *   }
 * }
 */
class BaseModule {
    constructor(baseClient) {
        this.baseClient = baseClient;
    }
}
exports.BaseModule = BaseModule;
//# sourceMappingURL=baseModule.js.map